import { services } from '../services';
var action = "report/";

export const paymentService = {
    getDetailPayment,
    getPrinciplePayment,
    getCollectPayment,
    getLatePayment,
    getUnitPayment,
    getUnitPaymentDetail
};

function getDetailPayment(param = '', uri='detail-payment') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getPrinciplePayment(param = '', uri='principle-payment') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getCollectPayment(param = '', uri='collect-payment') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getLatePayment(param = '', uri='late-payment') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getUnitPayment(param = '', uri='unit-payment') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}

function getUnitPaymentDetail(param = '', uri='unit-payment-detail') {
    return services.restApi(`${action}${uri}${param}`, 'GET');
}


